'use client'

import cn from 'classnames'
import { useTranslations } from 'next-intl'

import shared from '@booking/index.module.scss'
import styles from '../index.module.scss'

type FreeContinueProps = {
  onContinue: () => void
}

export default function FreeContinue({ onContinue }: FreeContinueProps) {
  const t = useTranslations('booking')

  return (
    <div className={styles.freeContinue}>
      <h4>{t('ticket.payment.free')}</h4>
      <button
        type="button"
        className={cn(shared.button, styles.freeButton, styles.shake)}
        onClick={() => onContinue()}
        data-id="continue"
      >
        {t('continue')}
      </button>
    </div>
  )
}
